/**
 * Response from sdk.timeslots.query API
 * @returns {Array<TimeslotDTO>} data
 **/
export const TimeslotsDTO = data => {
  return data.map(TimeslotDTO);
};

export const TimeslotDTO = data => {
  const { id, type, attributes } = data;
  return {
    id: {
      _sdkType: id?._sdkType,
      uuid: id?.uuid,
    },
    type: type,
    attributes: {
      type: attributes?.type,
      seats: attributes?.seats,
      start: attributes?.start,
      end: attributes?.end,
    },
  };
};
